/** @jsxImportSource @emotion/react */
import { css } from '@mui/material'

export const containerStyles = css`
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 999;
`
